import React from 'react';
import { Link } from 'react-router-dom'

const AssetListItem = (props) => {
    let category;
    if (props.item.category === "CPU") {
        category = props.item.category;
    } else {
        category = props.item.category !== undefined ? props.item.category.join(' | '): '';
    }
    return (
        <li className="asset-list-item py-3">
            <p className="asset-list-item-vendor mb-0" id="vendor">{props.item.vendor}</p>
            <Link className="asset-list-item-link" to={`/asset/${props.item.technopedia_id}`}>
                <h2 id="title">{props.item.title}</h2>
            </Link>
            <p className="asset-list-item-category mb-0" id="category">{category}</p>
        </li>
    )
};


export default AssetListItem;



// WEBPACK FOOTER //
// ./src/components/AssetListItem/AssetListItem.js